import Entity from 'utilities/Entity';

class Job extends Entity {}

export default new Job();
